import { SvgIconType } from './svg.interface';

const Clip: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#8792A2'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25 8.25V2.25C8.25 1.83579 7.91421 1.5 7.5 1.5C7.08579 1.5 6.75 1.83579 6.75 2.25V8.25C6.75 8.66421 6.41421 9 6 9C5.58579 9 5.25 8.66421 5.25 8.25V2.25C5.25 1.00736 6.25736 0 7.5 0C8.74264 0 9.75 1.00736 9.75 2.25V8.25C9.75 10.3211 8.07107 12 6 12C3.92893 12 2.25 10.3211 2.25 8.25V3C2.25 2.58579 2.58579 2.25 3 2.25C3.41421 2.25 3.75 2.58579 3.75 3V8.25C3.75 9.49264 4.75736 10.5 6 10.5C7.24264 10.5 8.25 9.49264 8.25 8.25Z"
      fill={color}
    />
  </svg>
);

export default Clip;
